import { Link as MuiLink, LinkProps } from "@material-ui/core";
import NextLink from "next/link";

export default function Link({ href, children, ...rest }: LinkProps) {
  return (
    <NextLink href={href}>
      <MuiLink href="" underline="hover" {...rest}>
        {children}
      </MuiLink>
    </NextLink>
  );
}
